export interface CompanyBenefitPolicyCheckoutDTO {
  hasActiveProfile: boolean;
  requiredDocuments: Array<CompanyBenefitPolicyRequiredDocumentDTO>;
  requiredCheckboxes: Array<CompanyBenefitPolicyRequiredCheckboxDTO>;
  requiredFields: Array<CompanyBenefitPolicyRequiredFieldDTO>;
}

export interface CompanyBenefitPolicyRequiredDocumentDTO {
  id: number;
  policyProfileId: number;
  language: PolicyLanguageEnum;
  documentName: string;
  displayName: string;
  documentUrl: string;
  isRequired: boolean;
  displayOrder: number;
}

export interface CompanyBenefitPolicyRequiredCheckboxDTO {
  id: number;
  policyProfileId: number;
  language: PolicyLanguageEnum;
  labelParts: Array<CompanyBenefitPolicyLabelPartModel>;
  isRequired: boolean;
  displayOrder: number;
}

export interface CompanyBenefitPolicyLabelPartModel {
  type: CompanyBenefitPolicyLabelPartTypeEnum;
  text: string;
  url: string;
}

export enum PolicyLanguageEnum {
  EN = 1,
  RO = 2
}

export enum CompanyBenefitPolicyLabelPartTypeEnum {
  Text = 1,
  Link = 2
}

export interface RequiredConsentState extends CompanyBenefitPolicyRequiredCheckboxDTO {
  checked: boolean;
  composedName: string;
}

export enum CompanyBenefitPolicyRequiredFieldTypeEnum {
  None = 0,
  Email = 1
}

export interface CompanyBenefitPolicyRequiredFieldDTO {
  id: number;
  policyProfileId: number;
  language: PolicyLanguageEnum;
  fieldType: CompanyBenefitPolicyRequiredFieldTypeEnum;
  fieldLabel: string;
  helperText: string;
  placeholder: string;
  isRequired: boolean;
  displayOrder: number;
}

export interface RequiredFieldState extends CompanyBenefitPolicyRequiredFieldDTO {
  value: string;
}
